import { ChecklistItem } from '@models/checklist';
import { MatterFileType } from '@models/matter';
import { BusinessWithSubscriptionStateModel } from '../../FirestoreStateBaseForBusiness';

export interface BusinessChecklistsModel
	extends BusinessWithSubscriptionStateModel {
	data: ChecklistItem[];
	sortOption: SortOption;
	selectedFileType: MatterFileType | 'all';
}

export enum SortOption {
	RECENTLY_CREATED = 'recentlyCreated',
	A_TO_Z = 'aToZ',
	DRAFT = 'draft',
	FIRM_CREATED = 'firmCreated',
	CLOSER_CREATED = 'closerCreated',
}

export enum SortOptionDropdownName {
	RECENTLY_CREATED = 'Recently created',
	A_TO_Z = 'A - Z',
	DRAFT = 'Draft',
	FIRM_CREATED = 'Firm created',
	CLOSER_CREATED = 'Closer created',
}
